export const calculateFreeShippingProgress = (cartSubtotal, countryCode) => {
  // Get thresholds from window.Shopify (set in theme.liquid)
  const thresholds = {
    AU: window.Shopify?.free_shipping_threshold_au,
    NZ: window.Shopify?.free_shipping_threshold_nz,
    INTL: window.Shopify?.free_shipping_threshold_intl,
  };

  // Determine threshold based on country
  const threshold = thresholds[countryCode] || thresholds.AU;
  
  // Calculate progress values
  const amountLeft = Math.max(0, threshold - cartSubtotal);
  const progress = Math.min(cartSubtotal / threshold, 1);
  const progressPercent = Math.round(progress * 100);
  const isUnlocked = cartSubtotal >= threshold;
  
  return {
    threshold,
    amountLeft,
    progress,
    progressPercent,
    isUnlocked,
    countryCode,
    cartSubtotal
  };
};

// Format currency based on country
export const formatCurrencyByCountry = (amount, countryCode) => {
  const currencyMap = {
    AU: 'AUD',
    NZ: 'NZD',
    INTL: 'USD'
  };
  
  const currency = currencyMap[countryCode] || 'AUD';
  const symbol = {
    AUD: '$',
    NZD: '$',
    USD: '$'
  };
  
  return `${symbol[currency]}${amount.toFixed(2)}`;
};